module.exports = __webpack_public_path__ + "assets/img/icon_words.01ca0fa4.png";